var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSamOsobowy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 237.5 108.98",
    width: 110,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .d {\r\n        fill: none;\r\n        stroke-linecap: round;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 8px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    "data-name": "Layer 1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "d",
    stroke: "#000",
    x1: 79.56,
    y1: 89.94,
    x2: 151.22,
    y2: 90.83
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    stroke: "#000",
    x1: 57.25,
    y1: 41.06,
    x2: 166.26,
    y2: 47.48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    stroke: "#000",
    cx: 46.82,
    cy: 86.4,
    r: 18.58
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    stroke: "#000",
    cx: 183.07,
    cy: 86.4,
    r: 18.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    stroke: "#000",
    d: "M15.78,89.94H7.89l-3.83-19.81c-.88-4.54,8.26-28.87,8.26-28.87,0,0,3.16-7.06,7.06-7.06l22.79-.68,14.99-21.4c5.2-5.2,12.25-8.12,19.6-8.12h58.89c6.93,0,13.6,2.65,18.64,7.42l28.78,27.21,45.12,15.04,5.31,19.46v17.69h-19.32"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSamOsobowy);
export default __webpack_public_path__ + "static/media/sam_osobowy.5312c99320470d9467e6f9b79d8e745a.svg";
export { ForwardRef as ReactComponent };